<template>
  <ul 
    v-if="list.length"
    v-rellax="{ list, rellaxSpeed }"
    class="categories-list">
    <li 
      v-for="(category, index) of list"
      :key="index"
      v-lazy-container="{ selector: 'img' }"
      class="category-list__home_hover">
      <router-link :to="{ name: 'single-category', params: { slug: category.fields.slug } }">
        <img
          v-if="typeof category.fields.imageSet !== 'undefined'"
          :data-src="category.fields.imageSet.fields.file.url"
          :data-loading="lazyLoading"
          :alt="category.fields.imageSet.fields.description"
          :width="category.fields.imageSet.fields.file.details.image.width"
          :height="category.fields.imageSet.fields.file.details.image.height">
        <p>{{ category.fields.title }}</p>
        <span>{{ $_getProductsCount(category.fields.slug) }} prodotti</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Rellax from 'rellax'
export default {
  name: 'CategoriesList',
  data: () => ({
    lazyLoading: require('@/assets/lazy/home-category.png'),
    loading: true,
    rellaxRef: undefined
  }),
  props: {
    list: {
      type: Array,
      required: true
    },
    rellaxSpeed: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'products',
      'nodes'
    ])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts',
      'loadNodes'
    ]),
    $_getProductsCount (currentSlug) {
      const currentNode = this.nodes.find(node => {
        return node.fields.category.fields.slug === currentSlug
      })
      return this.$_getCategoryProducts([currentNode]).length
    },
    $_getCategoryProducts (nodes) {
      var products = []
      nodes.forEach(node => {
        if (typeof node.fields.products !== 'undefined') products = products.concat(node.fields.products)
        if (typeof node.fields.nodesList !== 'undefined') products = products.concat(this.$_getCategoryProducts(node.fields.nodesList))
      })
      return products
    },
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadProducts(), this.loadNodes()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  },
  directives: {
    'rellax': {
      inserted (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined'){
          const rellaxRef = new Rellax(el, {
            speed: binding.value.rellaxSpeed,
            center: false,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false
          })
          vnode.context.$data.rellax = rellaxRef
        }
      },
      componentUpdated(el, binding, vnode){
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.refresh()
      },
      unbind (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.destroy()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./list.scss";
</style>
